import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useSendTaskMail = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base
        .post(`${config.appUrls.api}/api/template/sendTaskMail`, values)
        .then(res => res.data), {
        onError: e => {
            handleHttpError(intl)(e);
        },
    });
    return {
        sendTaskMail: mutateAsync,
        isLoading,
        error,
    };
};
